import classNames from 'classnames';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Empty, Loading } from 'tdesign-react';

import { useInfiniteScrollRender } from '@/hooks/useInfiniteScrollRender';
import { LibraryObjectData } from '@/interface/library';

import styles from './index.module.less';

export const InteractionList: React.FC<{
  onChange: (material: {
    value: string
    label: string
  }) => void;
  getNextPage: () => void;
  onClose: () => void;
  value: LibraryObjectData;
  list: {
    label: string,
    value: string
  }[];
  hasNext: boolean;
  firstLoading: boolean;
}> = (props) => {
  const {
    value, list = [], firstLoading, hasNext,
    onChange, onClose, getNextPage,
  } = props;

  const { containerRef, wrapperRef } = useInfiniteScrollRender({
    currentList: list || [],
    hasNextPage: hasNext || false,
    getNextPage,
  });

  const handleChooseMaterial = (material: {
    value: string
    label: string
  }) => {
    onChange(material);
    onClose();
  };

  return (
    <div ref={containerRef} className={styles.listContainer} id="scrollableHeaderPanel" >
      <InfiniteScroll
        height={100}
        hasMore={hasNext || false}
        dataLength={list.length}
        loader={
          <div className={classNames(styles.loadingWrapper, { [styles.full]: !list.length })}>
            <Loading size="small" text="加载中..." />
          </div>
        }
        scrollableTarget="scrollableHeaderPanel"
        next={getNextPage}
      >
        {list.length ? (
          <div ref={wrapperRef}>
            {list.map?.((e: { value: string, label: string }, index: number) => (
              <div className={classNames(styles.item, {
                [styles.active]: value?.materialId === e?.value,
              })} key={index} onClick={() => handleChooseMaterial(e)}>{e?.label}</div>
            ))}
          </div>
        ) : (
          <>
            {!hasNext && (
              <span className={styles.emptyWrapper}>
                {
                  firstLoading
                    ? <Loading size="small" text="加载中..." />
                    : <Empty size="small" />
                }
              </span>
            )}
          </>
        )}
      </InfiniteScroll>
    </div>
  );
};
